(() => {
  if (window.lamenaTabsReady) return;
  window.lamenaTabsReady = true;
  const select = (button) => {
    const section = button.closest('[data-lamena-tabs]');
    if (!section) return;
    section.querySelectorAll('[data-lamena-target]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    section.querySelectorAll('[data-lamena-panel]').forEach(panel => { panel.hidden = panel.id !== button.dataset.lamenaTarget; });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lamena-target]');
    if (button) select(button);
  });
  document.addEventListener('shopify:block:select', event => {
    const button = event.target.closest('[data-lamena-target]');
    if (button) select(button);
  });
})();

(() => {
  if (window.lamenaLooksReady) return;
  window.lamenaLooksReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-lamena-look]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lamenaLook);
      if (dialog && !dialog.open) { dialog.showModal(); document.documentElement.classList.add('lamena-look-open'); }
    }
    const close = event.target.closest('[data-lamena-look-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.lamena-look-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.lamena-look-dialog')) document.documentElement.classList.remove('lamena-look-open');
  }, true);
})();

(() => {
  if (window.lamenaGridReady) return;
  window.lamenaGridReady = true;
  let columns = '4';
  try { columns = sessionStorage.getItem('lamena-grid-columns') || '4'; } catch (_) {}
  if (!['4','5','7'].includes(columns)) columns = '4';
  const apply = () => document.querySelectorAll('[data-lamena-grid]').forEach(grid => {
    grid.dataset.lamenaColumns = columns;
    grid.querySelectorAll('[data-lamena-columns-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lamenaColumnsButton === columns)));
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lamena-columns-button]');
    if (!button) return;
    columns = button.dataset.lamenaColumnsButton;
    try { sessionStorage.setItem('lamena-grid-columns', columns); } catch (_) {}
    apply();
  });
  document.addEventListener('collection:reloaded', apply);
  document.addEventListener('shopify:section:load', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

(() => {
  const desktop = window.matchMedia('(min-width:769px)');
  const syncFooter = () => document.querySelectorAll('[data-lamena-footer-group]').forEach(group => { group.open = desktop.matches; });
  desktop.addEventListener('change', syncFooter);
  document.addEventListener('shopify:section:load', syncFooter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFooter); else syncFooter();
})();
